<template>
  <button type="submit" class="btn border-dark btn-submit" :disabled="isDisabled" :class="classes">
    <spinner v-if="busy" />
    <template v-else>
      {{ text || t("Change") }}
    </template>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Spinner from "@/components/spinner";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "submit-button",
});

const props = defineProps({
  busy: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: null,
  },
  isPrimary: {
    type: Boolean,
    required: false,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { t } = useI18n();

const classes = computed(() => ({
  "btn-primary": props.isPrimary,
  "btn-blue": !props.isPrimary,
  busy: props.busy,
}));
</script>

<style lang="scss">
@import "./index";
</style>
